import { forcedCoolingStagesAmount } from 'sigma-mappings';

const coolingStageAmountOptions = [
  {
    text: '0',
    value: forcedCoolingStagesAmount.ZERO,
  },
  {
    text: '1',
    value: forcedCoolingStagesAmount.ONE,
  },
  {
    text: '2',
    value: forcedCoolingStagesAmount.TWO,
  },
  {
    text: '3',
    value: forcedCoolingStagesAmount.THREE,
  },
  {
    text: '4',
    value: forcedCoolingStagesAmount.FOUR,
  },
];

export default coolingStageAmountOptions;
